import React from "react";

export const IfundefinedColumnFormatter = (cellContent, row, rowIndex, dIndexName) => (
  cellContent == undefined || 
  cellContent == "NA"||
  cellContent == ""||
  cellContent == null

  
  ? "-" : cellContent
  
);
